module.exports = __webpack_public_path__ + "assets-cabinet/img/success-checkmark-icon.5c469ebb.svg";